import { render } from "./ReviewDetails.vue?vue&type=template&id=86f53562&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"

import "./ReviewDetails.vue?vue&type=style&index=0&id=86f53562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f53562"]])

export default __exports__